import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Delete = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 6H21V9H11V6ZM9 9V6C9 4.89543 9.89543 4 11 4H21C22.1046 4 23 4.89543 23 6V9H23.7901H27C27.5523 9 28 9.44772 28 10C28 10.5523 27.5523 11 27 11H25.7903C25.7902 11.0657 25.7868 11.1321 25.7802 11.199L24.1802 27.199C24.0779 28.2214 23.2176 29 22.1901 29H9.81003C8.78253 29 7.9222 28.2214 7.81996 27.199L6.21996 11.199C6.21327 11.1321 6.20995 11.0657 6.20984 11H5C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9H8.21003H9ZM21 11H19.9459L19.057 27H22.1901L23.7901 11H21ZM17.9428 11H14.0571L14.946 27H17.0539L17.9428 11ZM12.0541 11H11H8.21003L9.81003 27H12.943L12.0541 11Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Delete
